import { useEffect, useState } from "react";
import { CalendarSection } from "./CalendarSection";
import { CardGrid, ImageStrip } from "./CardGrid";
import { CompulsorySubjects, EligibilityTool, SubjectGroups } from "./StudyTools";

function slugifyTitle(title) {
  return String(title || "section")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function ContentSection({ section, navigate, index = 0, cardOffset = 0, showMobileDownloadPrompts = false }) {
  const [expanded, setExpanded] = useState(index === 0);
  const panelId = `section-panel-${index}-${slugifyTitle(section.title)}`;

  useEffect(() => {
    setExpanded(index === 0);
  }, [index, section.title]);

  return (
    <section
      className={`content-block mobile-accordion ${expanded ? "is-expanded" : "is-collapsed"} ${
        section.variant ? `${section.variant}-block` : ""
      }`}
    >
      <div className="section-title-row">
        <div className="section-title-copy">
          {section.eyebrow ? <span className="section-eyebrow">{section.eyebrow}</span> : null}
          <h2>{section.title}</h2>
        </div>
        <button
          type="button"
          className="section-toggle"
          aria-expanded={expanded}
          aria-controls={panelId}
          onClick={() => setExpanded((current) => !current)}
        >
          <span>{expanded ? "Close" : "Open"}</span>
          <span className="section-toggle-arrow" aria-hidden="true">
            ↓
          </span>
        </button>
      </div>
      <div id={panelId} className="section-collapsible-content">
        {section.body?.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        )) ?? null}
        {section.bullets?.length ? (
          <ul className="bullet-list">
            {section.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        ) : null}
        {section.steps?.length ? (
          <ol className="step-list">
            {section.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        ) : null}
        {section.faq?.length ? (
          <div className="faq-list">
            {section.faq.map((item) => (
              <details key={item.question} className="faq-item">
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        ) : null}
        <CardGrid cards={section.cards} navigate={navigate} cardOffset={cardOffset} showMobileDownloadPrompts={showMobileDownloadPrompts} />
        <CompulsorySubjects subjects={section.compulsorySubjects} />
        <SubjectGroups groups={section.subjectGroups} />
        {section.eligibilityTool ? <EligibilityTool /> : null}
        <ImageStrip images={section.images} />
        {section.calendar ? <CalendarSection calendar={section.calendar} /> : null}
      </div>
    </section>
  );
}
